export const hasOpenTimecard = (timecard) => Boolean(
  timecard?.uuid && timecard?.startsOn && !timecard?.endsOn
);

export const clockActionFor = (timecard) => hasOpenTimecard(timecard) ? "out" : "in";

export const breakActionFor = (timecard) => {
  if (!hasOpenTimecard(timecard)) return null;
  return timecard?.breakStartedAt ? "end" : "start";
};
